/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#my-card[_ngcontent-%COMP%]{position:relative;border:1px solid #ffffff00}#my-card[_ngcontent-%COMP%]:after{content:\"\";position:absolute;top:0;left:50%;width:60px;height:60px;background-image:url(/assets/images/thumbnail.png);background-size:cover;background-repeat:no-repeat;transform:translate(-50%,-50%);border-top:inherit;border-top-color:transparent}"];
export { styles as styles };
